module.exports = __webpack_public_path__ + "img/Zooms3.e5ccb66c.jpg";